import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module

export default function coverTargetGridItem(itemId: string): boolean {
    let target = document.getElementById(itemId);
    let conflictDataAttribute = target && target.getAttribute('data-conflict');
    let targetHasConflicts: boolean = conflictDataAttribute && conflictDataAttribute === '1';
    // this will tell if the item has conflicts with others for day view peek and edit peek

    const isSingleDayView =
        surfaceStore.dateRangeType === DateRangeType.Day && getNumDaysInDayRange() === 1;
    const dayViewSplit = isSingleDayView && surfaceStore.isInSplitView;
    const dayViewMerged = isSingleDayView && !surfaceStore.isInSplitView;

    // We must cover the target in all cases except the case where the target is part of a non singular conflict group
    return (
        (dayViewMerged || (dayViewSplit && getSelectedCalendars().length === 1)) &&
        !targetHasConflicts
    );
}
